import LightningIcon from './icons/lightning.svg';
import ShareIcon from './icons/share.svg';
import { BannerType } from './types';
import { t } from '../../../infra/i18n';
export var createShareBannerConfig = function (onPrimaryClick, onClose) { return ({
    type: BannerType.Share,
    bannerProps: {
        title: t('engage:invite.banner_title'),
        description: t('engage:invite.banner_description'),
        buttonText: t('engage:invite.banner_button'),
        onPrimaryClick: onPrimaryClick,
        onClose: onClose,
        Icon: ShareIcon,
    },
}); };
export var createAutomatedCampaignBannerConfig = function (onSetupAutomatedCampaign, onClose) { return ({
    type: BannerType.AutomatedCampaign,
    bannerProps: {
        title: t('engage:banners.automated_campaigns.title'),
        description: t('engage:banners.automated_campaigns.description'),
        buttonText: t('engage:banners.automated_campaigns.button_text'),
        onPrimaryClick: onSetupAutomatedCampaign,
        onClose: onClose,
        Icon: LightningIcon,
    },
}); };
